import { http } from '@/utils'
// 人员信息详情
export const personnelDetails = (id?: any): any =>
  http.get(`/hrm/employee/${id}`, { params: { id } })
// 培训记录 添加/编辑
export const saveTraining = (data: any): any => http.post('/hrm/training', data)
// 培训记录 批量删除
export const deletesTraining = (data: any): any => http.delete('/hrm/trainings', { data })
